module.exports = __webpack_public_path__ + "static/media/AP.ab21ec76.svg";